<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">



<!--sidebar-->


<div class="col-12 md:col-2" v-if="$store.state.verifications.verification">
<div class=" show_on_mobile">
<Fieldset :legend="$store.state.verifications.verification.supplier.name" :toggleable="true" :collapsed="true">
</Fieldset>
</div>
<div class="content_card_content sticky_panel hide_on_mobile">
<h3 class=" text-primary mt-0">{{$filters.sidebartextadjust($store.state.languages.lang_phrases.verification)}}</h3>
<hr>




<!-- status-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{$store.state.languages.lang_phrases.durum}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >



<template v-if="$store.state.verifications.verification.status=='awaiting_schedule'">
<Tag 
class="mt-1 custom-chip ml-0" 
:value="$store.state.languages.lang_phrases.planlama_bekliyor" 
style="background-color:#352f8d"
/>
</template> 

<template v-if="$store.state.verifications.verification.status=='scheduled'">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases.planlandi" 
style="background-color:#7e2f8d"
/>
</template> 

<template v-if="$store.state.verifications.verification.status=='completed'">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases.tamamlandi0" 
style="background-color:#4dc247"
/>
</template> 

<template v-if="$store.state.verifications.verification.status=='canceled'">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases.iptal_edildi" 
style="background-color:#a82400"
/>
</template> 

<template v-if="$store.state.verifications.verification.status=='rescheduled'">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases.tekrar_planlandi" 
style="background-color:#ff6600"
/>
</template>

<template v-if="$store.state.verifications.verification.status=='on_planning'">
<Tag 
class="ml-0 mt-1 custom-chip" 
:value="$store.state.languages.lang_phrases.planlamada" 
style="background-color:#3b82f6"
/>
</template> 

</div>
<!-- status-->

<!-- supplier-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{$store.state.languages.lang_phrases.tedarikci}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link">
<router-link class="no-underline text-primary text-sm" :to="{ name: 'Supplier', params: { id: $store.state.verifications.verification.supplier_id }}">{{$store.state.verifications.verification.supplier.name}}
  </router-link></small>

</div>
<!-- supplier-->

<!-- auditor-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.denetci}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" v-if="$store.state.verifications.verification.auditor">
<router-link class="no-underline text-primary text-sm" :to="{ name: 'User', params: { id: $store.state.verifications.verification.auditor.user.id }}">{{$store.state.verifications.verification.auditor.user.name}}
  </router-link></small>
<small class="font-bold text-sm text-orange-500" v-else>Tanımlanmamış</small>
</div>
<!-- auditor-->

<!-- brand-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.marka}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Brand', params: { id: $store.state.verifications.verification.flowsupplier.flow.brand.id }}">{{$store.state.verifications.verification.flowsupplier.flow.brand.name}}
  </router-link>
</small>
</div>
<!-- brand-->

<!-- project-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.proje}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Project', params: { id: $store.state.verifications.verification.flowsupplier.flow.project.id }}">{{$store.state.verifications.verification.flowsupplier.flow.project.name}}
  </router-link>
</small>
</div>
<!-- project-->



<!-- flow-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.akis}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Flow', params: { id: $store.state.verifications.verification.flowsupplier.flow.id }}">{{$store.state.verifications.verification.flowsupplier.flow.name}}
  </router-link>
</small>
</div>
<!-- flow-->


<!-- questionlist-->
<div class="col-12">
<h4 class="text-primary m-0"><b>{{this.$store.state.languages.lang_phrases.soru_listesi}}</b></h4>
</div>
<div class="col-12 mb-2 py-1" >
<small class="p-link" >
  <router-link class="no-underline text-primary text-sm" :to="{ name: 'Questionlist', params: { id: $store.state.verifications.verification.flowsupplier.flow.questionlist.id }}">{{$store.state.verifications.verification.flowsupplier.flow.questionlist.name}}
  </router-link>
</small>
</div>
<!-- questionlist-->

<!-- other_verifications-->
<template v-if="other_verifications">
  

<div class="col-12">
<h5 class="text-red-600 m-0"><b>Bu tedarikçinin başka doğrulama görüşmeleri de var</b></h5>
</div>
<div class="col-12 mb-2 py-1" >
<Button type="button"  label="Diğer Doğrulamaları Göster" class="p-button-primary p-button-outlined p-button-sm "  @click="showOtherVerfModal"/> 
</div>
</template>
<!-- other_verifications-->









</div>
</div>


<!--sidebar-->


<div class="col-12 md:col-10">
<div class="content_card_content">

<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>

<!--
<OtherVerificationsModal ref="otherverificationsmodal" :verifications="other_verifications" :supplier="item.supplier"></OtherVerificationsModal>
-->

</div>

 </div> 
</template>

<script>
import OtherVerificationsModal from "./OtherVerificationsModal"
export default {

  name: 'AuditorVerification',

  data () {
    return {
      item:null,
      tabs: [
          {
              title: 'durum',
              icon: 'chart-line',
              route:'schedule'
          },
      ],

    }
  },
  components:{OtherVerificationsModal},
  computed:{
    projectcount()
    {
      return this.$store.state.brands.projects.length
    },
    flowcount()
    {
      return this.$store.state.brands.flows.length
    },
    suppliercount()
    {
      return this.$store.state.brands.suppliers.length
    },
    other_verifications()
    {
      return false
      if(this.item)
      {
        let verifications = this.item.supplier.verifications
        let others = verifications.filter((item)=>{return item.id !== this.item.id})
        if(others.length)
        {
          return others
        }
      }
    },
  },
  mounted()
  {
    
    this.getData()
    this.checkTabName(this.tabs)
  },
  methods:{
    showOtherVerfModal()
    {
      this.$refs.otherverificationsmodal.showModal()
    },
  	async getData()
    {
        this.item = await this.generalApiGetWithoutLoader("verification/"+this.$route.params.id)         
        this.$store.dispatch('verifications/setVerification',this.item)  



        for(let tab of this.tabs)
        {
          tab.route = await "/"+this.$store.state.auth.user.uuid+"/verification/"+this.$route.params.id+"/"+tab.route
        }
    }
  }
};
</script>

<style lang="css">
  
</style>